export const IS_DEV = true
export const APP_VERSION = "1.2.0";
// export const APIS_URL = IS_DEV ? "http://localhost:5004/apis/" : ""
export const URL_COMPANY = "https://www.anvitapharma.com/";
export const URL_LINKEDIN = "https://id.linkedin.com/company/pt-anvita-pharma-indonesia";
export const URL_INSTAGRAM = "";